import { useState, useEffect } from "react";
import {
    Theme,
    Box,
    useMediaQuery,
    Grid,
} from "@material-ui/core";

import { Pagination } from "@material-ui/lab";
import PropertyCard from "./PropertyCard";
import { Property } from "../models/Property";
import { fetchPagedPropertiesWithLimit } from "../services/propertyService";
import { useEffectAsync } from "../hooks/useEffectAsync";
import CustomSearch from "../pages/pages/FAR/CustomSearch";
import {getTextByCurrentLanguage} from "../utils/functions";

function PropertiesCardPagination( props: {token: string, onActiveProperty: Function}) {

    const [count, setCount] = useState(0);
    const [page, setPage] = useState(1);
    const [properties, setProperties] = useState<Array<Property>>([]);
    const [activeProperty, setActiveProperty] = useState<Property>();
    const [filteredItems, setFilteredItems] = useState<any>([])

    useEffect(() => props.onActiveProperty(activeProperty), [activeProperty]);

    const fetchData = async () => {
        if (props.token) {
            const properties = await fetchPagedPropertiesWithLimit(props.token, page, 6);
            setActiveProperty(properties.data.results[0]);
            setProperties(properties.data.results);
            setCount(properties.data.count);
        }
    }

    useEffectAsync(async () => {
        await fetchData()
    }, [])

    useEffect(() => {
        if (filteredItems.length > 0) {
            setActiveProperty(filteredItems[0])
            setProperties(filteredItems.slice(0, 6))
            setCount(filteredItems.length)
            setPage(1)
        } else {
            fetchData()
            setPage(1)
        }
    }, [filteredItems])


    const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const handleChangePage = async (event: React.ChangeEvent<unknown>, page: number) => {
        if (filteredItems.length > 0) {
            setProperties(filteredItems.slice(page * 6 - 6, page * 6))
            setPage(page)
            return
        }

        if (props.token) {
            const properties = await fetchPagedPropertiesWithLimit(props.token, page, 6);
            setProperties(properties.data.results);
            setPage(page);
        }
    };

    const onCardClick = (property: Property) => setActiveProperty(property);


    return (
        <>
            {(count >= 1) ?
                <Box mt={6}>
                    <Grid container spacing={4}>
                        {(properties && activeProperty) ?
                            properties.map((property : any, idx: number) => (
                                <Grid key={idx} item xs={6} sm={6} md={4} lg={2}>
                                    <PropertyCard
                                      key={idx}
                                      active={activeProperty.id === property.id}
                                      title={getTextByCurrentLanguage(property.name)}
                                      onCardClick={() => onCardClick(property)} />
                                </Grid>
                            )) : null
                        }
                    </Grid>
                    <br />
                    <div style={{display: 'flex'}}>
                        {(count > 6) ? (
                           <Pagination
                             size={sm ? "small" : "medium"}
                             count={Math.ceil(count / 6)}
                             page={page}
                             onChange={handleChangePage}
                             showFirstButton
                             showLastButton />
                        ) : null}
                        <CustomSearch selectedItemsToSearch={setFilteredItems}/>
                    </div>
                </Box> : null
            }
        </>
    )
};

export default PropertiesCardPagination;
